import { render, staticRenderFns } from "./EmailRegistration.vue?vue&type=template&id=535e03e1&scoped=true&"
import script from "./EmailRegistration.vue?vue&type=script&lang=ts&"
export * from "./EmailRegistration.vue?vue&type=script&lang=ts&"
import style0 from "./EmailRegistration.vue?vue&type=style&index=0&id=535e03e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535e03e1",
  null
  
)

export default component.exports